module.exports = __webpack_public_path__ + "static/media/v9.af727b04.mp4";